/* eslint-disable */
import React, { useContext } from 'react';

// Custom Components
import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

// Models
import modelPoi from '@/models/cesta_put_poi';
import modelCestaPut from '@/models/ceste_putevi';

// Types
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import UserContext from '@/context/UserContext/UserContext';

type CestePuteviDataCentricPageParams = {};

const PoiDataCentricPage = (
  props: CestePuteviDataCentricPageParams
) => { 
  const userContext = useContext(UserContext);
  const canEdit = userContext?.hasAnyPermission([Permissions.CestovnaInfrastrukturaEdit]);
  
  return (
    <AppPage
      titlett="cestovna_infrastruktura:page.tocke_interesa"
      needPermission={[Permissions.CestovnaInfrastruktura]}
    >
      <DataCentricPage
        primaryModel={modelPoi}
        primaryTitleToken="titles.tocke_interesa"
        primaryView='default'
        secondaryModel={modelCestaPut}
        secondaryTitleToken="titles.ceste_u_blizini"
        secondaryView='default'
        baseRecordPath={modelPoi.apiPath}
        childRecordRelativePath="nearby-paths"
        geomRelativePath=""
        mapId={52}
        mapModel={modelPoi}
        primaryAllowView
        primaryAllowEdit={canEdit}
        primaryAllowAdd={canEdit}
        allowPrimaryModelActivate={true}
        allowShowSecondaryOnMap={true}
        geometryChangeType='Point'
      />
    </AppPage>
  )}

export default PoiDataCentricPage;